import React from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import clsx from 'clsx';

import withSettings from '../../../utils/withSettings';
import styles from '../styles';
import { translate } from '../../../i18n/I18nProvider';
import SubscriptionCsvDownload from './SubscriptionCsvDownload';
import { actions as reduxActions } from '../reducers';
import RefreshButton from '../../../partials/tableCustomButtons/RefreshButton';

const SubscriptionsHeader = ({ classes, settings, setRefresh }) => {
  return (
    <div
      className={classes.headerRoot}
      style={{ color: settings.colors.primary }}
    >
      <div className={classes.label}>
        <i className={clsx('fas fa-business-time', classes.icon)}></i>
        <div className={classes.title}>{translate('MENU.SUBSCRIPTIONS')}</div>
      </div>
      <div className={classes.actionContainer}>
        <SubscriptionCsvDownload />
        <RefreshButton onClick={() => setRefresh(true)} tableHeader={true} />
      </div>
    </div>
  );
};

const mapStatesToProps = ({ loader, auth }) => {
  return {
    isLoading: loader.isSpinVisible,
    lang: auth.lang
  };
};

const mapDispatchToProps = {
  setRefresh: reduxActions.setRefresh
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(SubscriptionsHeader);
